import {z} from 'zod';

import {isNil, isNotNil} from 'ramda';
import {isNilOrEmpty} from 'ramda-adjunct';

import {AftersalesPaymentMethodSchema} from '@dms/api/sales';
import i18n from '@dms/i18n';

const MIN_DUE_DAYS = 0;
const MAX_DUE_DAYS = 3650;

export const checkoutPaymentFormSchemaV2 = z
  .object({
    amount: z.number(),
    method: AftersalesPaymentMethodSchema,
    issueDate: z.date(),
    bankAccount: z.string().nullish(),
    cashRegisterId: z.string().nullish(),
    due: z.number().min(MIN_DUE_DAYS).max(MAX_DUE_DAYS),
    dueDate: z.date(),
    dateOfTaxableSupply: z.date(),
    note: z.string().nullish(),
    exchangeRate: z.number().min(0).nullish(),
    currency: z.string().nullish(),
    customerServiceContractId: z.string().nullish(),
    templateId: z.string().nullish(),
    correctionReason: z.string().nullish(),
    dateOfReception: z.date().nullish(),
  })
  .superRefine((data, ctx) => {
    if (data.method === 'BANK_TRANSFER' && isNilOrEmpty(data.bankAccount)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['bankAccount'],
      });
    }

    if (data.method === 'CASH' && isNilOrEmpty(data.cashRegisterId)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['cashRegisterId'],
      });
    }

    if (isNotNil(data.currency) && isNil(data.exchangeRate)) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: i18n.t('general.validations.fieldIsRequired'),
        path: ['exchangeRate'],
      });
    }
  });

export type CheckoutPaymentFormTypeV2 = z.infer<typeof checkoutPaymentFormSchemaV2>;
